import { Injectable } from '@angular/core';
import { ToastrService as ToastrLibService } from 'ngx-toastr';
import { CheckboxMessageComponent } from '../../components/toastr-templates/checkbox-message/checkbox-message.component';
import { DomSanitizer } from '@angular/platform-browser';
import { ErrorMessageComponent } from 'src/app/components/toastr-templates/error-message/error-message.component';
import { CustomToastrComponent } from 'src/app/components/toastr-templates/custom-toastr/custom-toastr.component';

@Injectable({
  providedIn: 'root'
})
export class ToastrService {

  constructor(private toastr: ToastrLibService, private domSanitizer: DomSanitizer) {

  }

  checkboxMessage(message: string): void {
    this.toastr.show(message, null, {
      toastComponent: CheckboxMessageComponent,
      toastClass: '',
      positionClass: 'toast-top-center-pos',
      timeOut: 2000,
      easeTime: 100
    });
  }

  errorMessage(message: string): void {
    this.toastr.show(message, null, {
      toastComponent: ErrorMessageComponent,
      toastClass: '',
      positionClass: 'toast-top-right',
      timeOut: 2000,
      easeTime: 100
    });
  }

  errMessage(message?: string, title?: string): void {
    const toastRef = this.toastr.show(message, title, {
      toastComponent: CustomToastrComponent,
      toastClass: '',
      positionClass: 'custom-toast-top-right',
      timeOut: 10000,
      easeTime: 100,
    });
    if (toastRef.toastRef.componentInstance) {
    toastRef.toastRef.componentInstance.type = 'error';
    }
  }

  successMessage(message?: string, title?: string): void {
    const toastRef = this.toastr.show(message, title, {
      toastComponent: CustomToastrComponent,
      toastClass: '',
      positionClass: 'custom-toast-top-right',
      timeOut: 10000,
      easeTime: 100
    });
    if (toastRef.toastRef.componentInstance) {
    toastRef.toastRef.componentInstance.type = 'success';
    }
  }

  clear(id?: number): void {
    this.toastr.clear(id);
  }
}
